export * from "./mapSelectionNames";